import { ButtonBase } from '@mui/material';
import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled, { css } from 'styled-components';

interface StyledProps {
  active: boolean;
  isDisabled: boolean;
  theme: any;
}

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  border: 1px solid ${COLORS.GREEN};
  border-radius: 25rem;
  max-width: 80%;
  width: 100%;
  margin-top: 20rem;

  ${respondTo.horizontalTablet`
    max-width: 300rem;
  `}
`;

export const Text = styled.span`
  font-size: 16rem;
  display: inline-block;
  color: ${COLORS.GREEN};
  white-space: nowrap;
  transition: all 0.3s;
  width: 100%;
  max-width: 100%;
`;

export const Mode = styled(ButtonBase)`
  display: flex;
  justify-content: center;
  width: 100%;
  border-radius: 21rem;
  background-color: transparent;
  padding: 10rem 20rem;
  cursor: pointer;
  transition: all 0.3s;

  ${(props: StyledProps) =>
    props.active &&
    css`
      background-color: ${COLORS.GREEN};
      ${Text} {
        color: ${COLORS.STRICT_WHITE};
      }
    `};

  ${(props: StyledProps) =>
    !props.active &&
    css`
      &:hover {
        ${Text} {
          color: ${COLORS.BLACK};
        }
        ${Wrapper} {
          background-color: ${COLORS.GREEN_DISABLED};
        }
      }
    `};

  ${(props: StyledProps) =>
    props.isDisabled &&
    css`
      ${Text} {
        color: ${props.theme.dark ? COLORS.BORDER : COLORS.BACKDROP};
      }
      cursor: not-allowed;
    `}

  ${respondTo.horizontalTablet`
    padding: 10rem 15rem;
  `}
`;
